


















import Vue from 'vue'
import TheHeader from '@app/components/common/TheHeader.vue'
import SubHeader from '@app/components/common/SubHeader.vue'
import TheFooter from '@app/components/common/TheFooter.vue'
import usePageCommon from '@app/composable/usePageCommon'
import { defineComponent } from '@nuxtjs/composition-api'
import ShowToasts from '@app/components/common/ShowToasts.vue'
export default defineComponent({
  components: {
    TheHeader,
    TheFooter,
    SubHeader,
    ShowToasts,
  },
  transition: 'page',
  setup() {
    const { loading, errorMessage, lang } = usePageCommon()
    return {
      loading,
      errorMessage,
      lang,
    }
  },
  head: {
    script: [
      {
        src: 'https://d.shutto-translation.com/trans.js?id=17746',
      },
    ],
  },
})
